import Swiper from 'swiper/bundle';

export const initProductsSlider = () => {
    // VARS
    const slider = document.querySelector('[data-swiper="products"]');
    if (!slider) return;
    const brands = document.querySelectorAll('[data-products-brand]');
    const activeClass = '--active';

    // INITS
    const swiper = new Swiper('[data-swiper="products"]', {
        grabCursor: true,
        loop: true,
        spaceBetween: 16,
        pagination: {
            el: '[data-swiper-pagination="products"]',
            clickable: true,
        },
        navigation: {
            nextEl: '[data-swiper-button-next="products"]',
            prevEl: '[data-swiper-button-prev="products"]',
        },
        on: {
            realIndexChange: (swiper) => setActiveBrand(swiper.realIndex),
        },
    });

    // LISTENERS
    brands.forEach((brand) => {
        brand.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            swiper.slideToLoop(Number(brand.dataset.productsBrand));
        });
    });

    // FUNCTIONS
    function setActiveBrand(index) {
        brands.forEach((brand) => {
            brand.classList.toggle(activeClass, Number(brand.dataset.productsBrand) === index);
        });
    }
};
